import React from "react";
import banner from "../Images/banner.jpg";
import { Col } from "react-bootstrap";
import "animate.css";
import { goToTheSpecificSectionFunc2 } from "../utils/goToTheSpecificSection";

export default class Intro extends React.Component {
    goToThatSpecificSection(e) {
        goToTheSpecificSectionFunc2(e);
    }
    render() {
        return (
            <div>
                <div style={styles.introContiner} id="introBackground"></div>
                <div style={styles.introTextOverlay} className="animated slideInRight">
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <h2 style={styles.introText} id="intro_text">
                            <span className="introTextSpan" style={styles.introTextSpan}>Hello..!</span>
                            <span className="introTextSpan" style={styles.introTextSpan}>I'm Ahsan Usman</span>
                            FULLSTACK DEVLOPER
                </h2>
                    </Col>
                    <button style={styles.learnMoreBTN} className="learnMore" onClick={this.goToThatSpecificSection.bind(this, this.props.about)}>LEARN MORE</button>
                </div>
            </div>
        );
    }
}

const styles = {
    introContiner: {
        backgroundImage: `url(${banner})`,
        height: `${window.screen.height - 100}px`,
        filter: "brightness(0.7)",
        position: "relative"
    },
    introText: {
        color: "#fff",
        textAlign: "right",
        fontFamily: "Roboto, sans-serif",
        fontWeight: 600,
        marginTop: 0,
        height: "inherit",
        paddingRight: "4%",
        paddingTop: "30%",
        fontSize: 57
    },
    introTextSpan: {
        fontSize: 32,
        fontWeight: 400,
        display: "block"
    },
    learnMoreBTN: {
        width: 175,
        height: 50,
        backgroundColor: "#c80a48",
        color: "#fff",
        border: "1px solid #c80a48",
        fontWeight: 700,
        fontSize: 16,
        marginRight: 20,
        position: "relative",
        left: "66%",
        outline: "none",
        transition: "all .40s ease"
    },
    introTextOverlay: {
        position: "absolute",
        top: "2%",
        right: "2%"
    }
};


// WEBPACK FOOTER //
// ./src/Components/portfolioIntro.jsx